import React, { useEffect, useState } from 'react';
import { dismissNotification, subscribeNotifications, type Notification } from '../utils/notify';

const styles: Record<Notification['type'], string> = {
  error: 'border-red-200 bg-red-50 text-red-700 dark:border-red-800 dark:bg-red-950/90 dark:text-red-200',
  success: 'border-emerald-200 bg-emerald-50 text-emerald-700 dark:border-emerald-800 dark:bg-emerald-950/90 dark:text-emerald-200',
  info: 'border-blue-200 bg-blue-50 text-blue-700 dark:border-blue-800 dark:bg-blue-950/90 dark:text-blue-200',
};

const NotificationHost: React.FC = () => {
  const [items, setItems] = useState<Notification[]>([]);

  useEffect(() => subscribeNotifications(setItems), []);

  if (items.length === 0) return null;

  return (
    <div className="pointer-events-none fixed inset-x-0 top-4 z-[60] flex flex-col items-center gap-2 px-4">
      {items.map((n) => (
        <div
          key={n.id}
          role={n.type === 'error' ? 'alert' : 'status'}
          className={`pointer-events-auto flex w-full max-w-3xl items-start justify-between gap-3 rounded-2xl border px-5 py-3 text-sm shadow-sm ${styles[n.type]}`}
        >
          <span className="whitespace-pre-line">{n.message}</span>
          <button
            type="button"
            onClick={() => dismissNotification(n.id)}
            aria-label="Fechar aviso"
            className="shrink-0 text-lg leading-none opacity-60 hover:opacity-100"
          >
            ×
          </button>
        </div>
      ))}
    </div>
  );
};

export default NotificationHost;
